// extracted by mini-css-extract-plugin
module.exports = {"SideBarBack":"SideBar_SideBarBack__2K1n6","SideBarFront":"SideBar_SideBarFront__oIyZ-","Title":"SideBar_Title__2MIk2","Lists":"SideBar_Lists__2Z0DF"};